/**
 * Builds the queue entry of the board menu. It opens the queue on the role's default filter; the
 * count is always "Mine + not taken over", so for a head accountant or admin the two differ (decided).
 */
import type { MenuWrapperItem } from '@insio/ui-toolkit';
import { navigation } from '@/navigation';
import type { TranslateFn } from '@/types/i18n';
import { QueueMenuLink } from '../components/QueueMenuLink';

interface QueueMenuItemOptions {
  /** To do, mine and unhandled. */
  count: number;
  isActive: boolean;
  /** The `features.masterAccountBoardShell.menu` translator. */
  t: TranslateFn;
  /** Classes of the neighbouring menu links, so the entry lines up with them. */
  className: string;
}

export function queueMenuItem({
  count,
  isActive,
  t,
  className
}: QueueMenuItemOptions): MenuWrapperItem {
  const href = navigation.masterAccountQueue();
  const label = t('queue');
  return {
    // The mobile drawer renders only the label, so the count travels in it there.
    label: count > 0 ? t('queueWithCount', { count }) : label,
    icon: 'list-ul',
    href,
    isActive,
    item: (
      <QueueMenuLink
        href={href}
        label={label}
        count={count}
        isActive={isActive}
        className={className}
      />
    )
  };
}
